<template>
  <div>
    <div>
      <button
        aria-label="Toggle navigation"
        class="navbar-toggler"
        type="button"
        @click="menuVisible = !menuVisible"
      >
        <span class="navbar-toggler-icon" />
      </button>
    </div>

    <portal
      to="app-end"
    >
      <transition name="slide-left">
        <div
          v-if="menuVisible"
          class="menu"
          @click.passive="menuVisible = false"
        >
          <div class="menu-heading">
            My FFF
          </div>
          <MenuAccountLinks class="menu-list" />

          <div class="menu-heading">
            About FFF
          </div>
          <div class="menu-list">
            <router-link
              class="dropdown-item"
              :to="{ name: 'about'}"
            >
              About
            </router-link>
            <li class="nav-item ">
              <router-link
                class="dropdown-item"
                :to="{ name: 'food-spirals' }"
              >
                FOOD SPIRALs&reg;
              </router-link>
            </li>
            <router-link
              class="dropdown-item"
              :to="{ name: 'fitness-spirals' }"
            >
              Fitness SPIRALs&reg;
            </router-link>
            <router-link
              class="dropdown-item caret-after"
              :to="{ name: 'faq'}"
            >
              FAQ
            </router-link>
            <router-link
              class="dropdown-item"
              :to="{ name: 'blog'}"
            >
              Blog
            </router-link>
            <router-link
              class="dropdown-item"
              :to="{ name: 'recipes'}"
            >
              Recipes
            </router-link>
            <router-link
              class="dropdown-item"
              :to="{name: 'events'}"
            >
              Events
            </router-link>
            <a href="https://store.foodfitnessfirst.com/">
              <div class="dropdown-item">Store</div>
            </a>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div
          v-if="menuVisible"
          class="menu-backdrop"
          @click="menuVisible = false"
        />
      </transition>
    </portal>
  </div>
</template>

<script>
import MenuAccountLinks from "./MenuAccountLinks.vue";

export default {
  components: {MenuAccountLinks},
  data: () => ({
    menuVisible: false,
  }),
}
</script>

<style lang="scss" scoped>
.menu-backdrop {
  position: fixed;
  background: #333;
  inset: 0;
  z-index: 101;
  opacity: 0.8;
}

.menu {
  position: fixed;
  background: white;
  top: 64px;
  right: 0;
  bottom: 0;
  z-index: 102;

  padding: 0 1rem 1rem 0.6rem;

  overflow: scroll;
  overscroll-behavior: contain;
}

.menu-heading {
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 1rem;
}

.menu-list {
  margin-left: 1.2rem;
  list-style: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 300ms;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-left-enter-active, .slide-left-leave-active {
  transition: transform 300ms;
}
.slide-left-enter, .slide-left-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translate(100vw);
}
</style>
